// Tiny API client with JWT support and in-memory cache.
const TOKEN_KEY = 'tiq_token';
const USER_KEY = 'tiq_user';

export const Token = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); },
};

export const CurrentUser = {
  get: () => {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  },
  set: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
  clear: () => localStorage.removeItem(USER_KEY),
};

// Simple in-memory cache with TTL.
const cache = new Map();
const CACHE_TTL = 30_000; // 30 seconds

const cacheKey = (method, path, body) =>
  method + ':' + path + (body ? ':' + JSON.stringify(body) : '');

const cacheGet = (key) => {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expires) { cache.delete(key); return null; }
  return entry.value;
};

const cacheSet = (key, value) => {
  cache.set(key, { value, expires: Date.now() + CACHE_TTL });
  if (cache.size > 100) {
    const oldest = cache.keys().next().value;
    if (oldest) cache.delete(oldest);
  }
};

const cacheClear = () => cache.clear();
export const clearApiCache = cacheClear;

const request = async (method, path, body) => {
  const headers = { 'Content-Type': 'application/json' };
  const token = Token.get();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const opts = { method, headers };
  if (body !== undefined) opts.body = JSON.stringify(body);

  // Only cache GET requests.
  const cKey = method === 'GET' ? cacheKey(method, path, body) : null;
  if (cKey) {
    const cached = cacheGet(cKey);
    if (cached) return cached;
  }

  const res = await fetch(`/api${path}`, opts);
  const text = await res.text();
  let json = null;
  try { json = text ? JSON.parse(text) : null; } catch { json = { success: false, message: text }; }
  if (!res.ok) {
    const message = (json && json.message) || `Error en la solicitud (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.details = json && json.details;
    if (res.status === 401) {
      Token.clear();
      CurrentUser.clear();
      window.location.pathname = '/login';
    }
    throw err;
  }
  if (cKey) cacheSet(cKey, json);
  return json;
};

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => { cacheClear(); return request('POST', path, body || {}); },
  patch: (path, body) => { cacheClear(); return request('PATCH', path, body || {}); },
  put: (path, body) => { cacheClear(); return request('PUT', path, body || {}); },
  del: (path) => { cacheClear(); return request('DELETE', path); },
};
